/**
 * Grafana Service
 */

DM.Service.Grafana = (function (DM) {
    var URL_ENDPOINT = DM.Config.influxDbUrl;

    return {
        sendData: function (data) {
            return fetch(URL_ENDPOINT, {
                method: 'POST',
                body: JSON.stringify(data)
            })
        }
    }
})(window.DM);
